export default "__VITE_ASSET__B$s8$pWz__"